(() => {
  const initialize = (scope = document) => {
    scope.querySelectorAll('[data-gml-navigation]').forEach((root) => {
      if (root.dataset.gmlMobileMenuBound) return;
      root.dataset.gmlMobileMenuBound = 'true';
      const controller = new AbortController();
      const highlights = root.querySelector('[data-gml-mobile-highlights]');
      const features = root.querySelector('[data-gml-menu-features]');
      const sources = [
        root.querySelector('.gml-menu-tiles--editorial .gml-menu-tile--about'),
        root.querySelector('.gml-menu-tiles--editorial .gml-menu-tile--interests'),
        root.querySelector('.gml-menu-tiles--editorial .gml-menu-tile--services'),
        root.querySelector('.gml-menu-tiles--watches a[href$="#rolex"]')
      ];
      sources.filter(Boolean).forEach((source, index) => {
        const tile = source.cloneNode(true);
        tile.removeAttribute('id');
        tile.removeAttribute('data-gml-preview-block');
        Array.from(tile.attributes).filter((attribute) => attribute.name.startsWith('data-shopify-')).forEach((attribute) => tile.removeAttribute(attribute.name));
        tile.className = `gml-mobile-menu-highlight${index === 3 ? ' gml-mobile-menu-highlight--watch' : ''}`;
        tile.style.setProperty('--gml-order', index);
        if (index === 3) tile.style.setProperty('--gml-menu-fit', 'contain');
        const image = tile.querySelector('img');
        if (image) image.sizes = '(max-width: 749px) 44vw, 1px';
        highlights?.append(tile);
      });
      features?.querySelectorAll('.gml-menu-preview__heading').forEach((heading) => {
        const button = document.createElement('button');
        button.type = 'button';
        button.className = 'gml-mobile-menu-back';
        button.setAttribute('aria-label', features.dataset.gmlBackLabel);
        button.innerHTML = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="m10 5-7 7 7 7M3 12h18"/></svg>';
        heading.prepend(button);
        button.addEventListener('click', () => root.gmlCloseMobileMenuPreview?.(), { signal: controller.signal });
      });
      document.addEventListener('shopify:section:unload', (event) => {
        if (event.target.contains(root)) controller.abort();
      }, { signal: controller.signal });
    });
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => initialize(), { once: true });
  else initialize();
  document.addEventListener('shopify:section:load', (event) => initialize(event.target));
})();
